import { useState } from "react";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { PlusIcon } from "@heroicons/react/24/outline";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

import useWebhookForm from "./useWebhookForm";
import WebhookForm from "./WebhookForm";

export default WebhookAdd;

function WebhookAdd(props) {
  const { onWebhookAdd } = props;

  const [createWebhook, setCreateWebhook] = useState<boolean>(false);

  return (
    <>
      <Button
        color="white"
        onClick={() => setCreateWebhook(true)}
      >
        <PlusIcon /> Add Webhook
      </Button>
      {createWebhook && (
        <WebhookAddDialog
          onClose={() => setCreateWebhook(false)}
          onAdd={onWebhookAdd}
        />
      )}
    </>
  );
}

function WebhookAddDialog(props) {
  const { onClose, onAdd } = props;

  const { formState, updateFormState, validate, errors } =
    useWebhookForm();

  const [loading, setLoading] = useState<boolean>(false);

  const handleAdd = () => {
    if (!validate()) {
      return;
    }

    const init = () => {
      setLoading(true);
      message.loading("Adding Webhook");
    };

    const success = () => {
      setLoading(false);
      message.destroy();
      message.success("Webhook Added");
      onClose();
    };

    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to Add Webhook");
    };

    onAdd(formState, { init, success, error });
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>New Webhook</DialogTitle>
      <DialogBody>
        <WebhookForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          disabled={loading}
          onClick={handleAdd}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
